import { LinePlot } from './LinePlot';

export function LineChart({
  values,
  height = 180,
  color = '#3B82F6',
  selectedIndexes = [],
  onSelect,
}: {
  values: number[];
  height?: number;
  color?: string;
  selectedIndexes?: number[];
  onSelect?: (index: number) => void;
}) {
  return (
    <LinePlot
      series={[{ key: 'line', color, values }]}
      height={height}
      lineWidth={2.4}
      dot={9}
      selected={selectedIndexes.map((index) => ({ key: 'line', index }))}
      onSelect={onSelect ? (_key, index) => onSelect(index) : undefined}
    />
  );
}
